import { render, staticRenderFns } from "./MortgagesTable.vue?vue&type=template&id=13817394&"
import script from "./MortgagesTable.vue?vue&type=script&lang=ts&"
export * from "./MortgagesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports